import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Box, Fade, Button, Typography, Snackbar, Alert } from "@mui/material";
import {
  Save,
  Close,
  KeyboardReturn,
  Delete,
  SentimentVeryDissatisfied,
} from "@mui/icons-material";

import { DiaCard } from "../components/ceremonias/DiaCard";
import { AcolitosContext } from "../../context/AcolitosContext";
import { getAcolitosActivos } from "../../helpers/acolitos";
import { Loading } from "../../common/components";
import { CustomModal } from "../../common/components/CustomModal";
import {
  getCeremoniasWithAcolitos,
  putCeremonia,
  deleteCeremonia as deleteCeremoniaHelper,
} from "../../helpers/ceremonias";

export const DetallesCeremonia = () => {
  //nombre de la pestaña
  document.title = "Detalles de la ceremonia";

  //Get id cermonia from url
  const { id: idCeremonia } = useParams();

  const [acolitos, setAcolitos] = useState([]);
  const [loadingAcolitos, setLoadingAcolitos] = useState(true);
  const [rol, setRol] = useState([]);

  const [showModal, setShowModal] = useState(false);
  const [showNextCeremonia, setshowNextCeremonia] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [alertDelete, setAlertDelete] = useState(false);
  const [guardando, setGuardando] = useState(false);
  const [errorAlert, setErrorAlert] = useState(
    "Error: faltan campos por llenar."
  );

  useEffect(() => {
    //Obtener acólitos
    getAcolitosActivos().then((a) => {
      setAcolitos(a);
      setLoadingAcolitos(false);
    });
    getCeremoniasWithAcolitos(idCeremonia).then((cer) => {
      if (cer.length === 0) {
        setRol([]);
      }
      setRol([
        {
          id_dia: 1,
          clase: cer[0].clase,
          color_ornamentos: cer[0].color_ornamentos,
          festividad: cer[0].festividad,
          fecha: cer[0].dia,
          ceremonias: [
            {
              id_ceremonia: cer[0].id,
              tipo_misa: cer[0].id_tipo,
              horario: cer[0].horario.slice(0, 5),
              //Ordenar los acólitos por puesto, si es Misa Cantada el orden es:
              // Maestro de Ceremonias, Turiferario, Acólito 1, Acólito 2, CRUZ, HACHA 1, HACHA 2, HACHA 3, HACHA 4
              acolitos: cer[0].acolitos
                .sort((a, b) => {
                  if (a.puesto === "Maestro de Ceremonias") return -1;
                  if (b.puesto === "Maestro de Ceremonias") return 1;
                  if (a.puesto === "Turiferario") return -1;
                  if (b.puesto === "Turiferario") return 1;
                  if (a.puesto === "Acólito 1") return -1;
                  if (b.puesto === "Acólito 1") return 1;
                  if (a.puesto === "Acólito 2") return -1;
                  if (b.puesto === "Acólito 2") return 1;
                  if (a.puesto === "CRUZ") return -1;
                  if (b.puesto === "CRUZ") return 1;
                  if (a.puesto === "HACHA 1") return -1;
                  if (b.puesto === "HACHA 1") return 1;
                  if (a.puesto === "HACHA 2") return -1;
                  if (b.puesto === "HACHA 2") return 1;
                  if (a.puesto === "HACHA 3") return -1;
                  if (b.puesto === "HACHA 3") return 1;
                  if (a.puesto === "HACHA 4") return -1;
                  if (b.puesto === "HACHA 4") return 1;
                  return 0;
                })
                .map((acolito) => ({
                  id: acolito.id_rol,
                  id_acolito: acolito.id_acolito,
                  nombre: acolito.nombre,
                  id_puesto: acolito.id_puesto,
                  puesto: acolito.puesto,
                })),
            },
          ],
        },
      ]);
    });
  }, []);

  // Función para validar que todos los campos estén llenos
  const validarCampos = () => {
    let valido = true;

    rol.forEach((dia) => {
      if (
        dia.fecha === "" ||
        dia.fecha === null ||
        dia.fecha === "Invalid Date" ||
        dia.festividad === "" ||
        dia.color_ornamentos === "" ||
        dia.clase === 0
      ) {
        valido = false;
      }

      dia.ceremonias.forEach((ceremonia) => {
        if (
          ceremonia.horario === null ||
          ceremonia.horario === "" ||
          ceremonia.tipo_misa === "" ||
          ceremonia.acolitos.length === 0 ||
          ceremonia.acolitos.some(
            (acolito) =>
              acolito.id_acolito === 0 ||
              acolito.id_acolito === null ||
              acolito.id_puesto === 0 ||
              acolito.id_puesto === null
          )
        ) {
          valido = false;
        }
      });
    });

    return valido;
  };

  const guardarRol = async () => {
    setGuardando(true);
    if (validarCampos()) {
      const resp = await putCeremonia(rol);
      if (resp) {
        setShowModal(false);
        setshowNextCeremonia(true);
        setGuardando(false);
      } else {
        setErrorAlert("Error al guardar el rol: Revisa tu conexión a internet");
        setShowModal(false);
        setShowAlert(true);
        setGuardando(false);
      }
    } else {
      setShowModal(false);
      setShowAlert(true);
      setGuardando(false);
    }
  };

  const deleteCeremonia = async () => {
    if (typeof idCeremonia !== "number") {
      // Eliminar acolito de la base de datos
      await deleteCeremoniaHelper({ id: idCeremonia });
    }
    window.location.href = "/ceremonias";
  };

  //Mostrar cargando si no se han cargado los acolitos
  if (loadingAcolitos) {
    return <Loading texto="Obteniendo acólitos" />;
  }

  //Si la ceremonia no existe
  if (rol.length === 0) {
    return (
      <div>
        <Fade in={true} timeout={1000}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              height: "60vh",
            }}
          >
            <SentimentVeryDissatisfied
              style={{ fontSize: 100, marginBottom: 30 }}
              color="secondary"
            />
            <Typography
              id="transition-modal-title"
              variant="h4"
              color="secondary"
              fontWeight={500}
            >
              NO SE ENCONTRÓ LA CEREMONIA
            </Typography>
          </Box>
        </Fade>
      </div>
    );
  }

  return (
    <div>
      <AcolitosContext.Provider value={acolitos}>
        <Fade in={true} timeout={1000}>
          <Box sx={style.modal}>
            <Typography
              id="transition-modal-title"
              variant="h4"
              sx={style.modal_title}
              color="primary"
              fontWeight={900}
            >
              DETALLES DE LA CEREMONIA
            </Typography>
            {rol.map((dia) => (
              <DiaCard key={dia.id_dia} dia={dia} setRol={setRol} />
            ))}
            <div style={{ position: "fixed", bottom: 20, right: 20 }}>
              <Button
                startIcon={<Delete style={{ fontSize: 20 }} />}
                sx={{
                  borderRadius: 2,
                  boxShadow: 8,
                  transition: "transform 0.3s",
                  bgcolor: "error.main",
                  "&:hover": {
                    transform: "scale(1.1)",
                  },
                  fontSize: 20,
                  fontWeight: 900,
                  padding: "10px 20px",
                  marginRight: 10,
                  color: "white",
                }}
                onClick={() => setAlertDelete(true)}
              >
                Eliminar ceremonia
              </Button>
              <Button
                startIcon={<Save style={{ fontSize: 20 }} />}
                sx={{
                  borderRadius: 2,
                  boxShadow: 8,
                  transition: "transform 0.3s",
                  bgcolor: "white",
                  "&:hover": {
                    transform: "scale(1.1)",
                  },
                  fontSize: 20,
                  fontWeight: 900,
                  padding: "10px 20px",
                }}
                onClick={() => setShowModal(true)}
              >
                Guardar cambios
              </Button>
            </div>
          </Box>
        </Fade>
        {/* Modal para preguntar si desea regresar a la página principal */}

        <CustomModal
          open={showNextCeremonia}
          title="¡Ceremonia actualizada!"
          text="La ceremonia se actualizó correctamente"
          txtBtn1="Ir a las ceremonias"
          txtBtn2="Cerrar"
          funBtn1={() => (window.location.href = "/ceremonias")}
          funBtn2={() => {
            //Recargar la página
            window.location.reload();
          }}
          iconBtn1={<KeyboardReturn />}
          iconBtn2={<Close />}
        />
        {/* Modal para confirmar que deseamos guardar los cambios */}
        {
          <CustomModal
            open={showModal}
            funBtn1={guardarRol}
            funBtn2={() => setShowModal(false)}
            btnDisabled={guardando}
          />
        }
        {/* Modal para confirmar que desea eliminar la ceremonia */}
        <CustomModal
          open={alertDelete}
          title="¿Confirmas que deseas eliminar esta ceremonia?"
          text="Esta acción no se puede deshacer"
          txtBtn1="Eliminar"
          txtBtn2="Cancelar"
          funBtn1={() => deleteCeremonia()}
          funBtn2={() => setAlertDelete(false)}
          iconBtn1={<Delete />}
          iconBtn2={<Close />}
        />
        {/* Alerta de error */}
        <Snackbar
          open={showAlert}
          autoHideDuration={6000}
          onClose={() => setShowAlert(false)}
        >
          <Alert
            onClose={() => setShowAlert(false)}
            severity="error"
            variant="filled"
            sx={{ width: "100%" }}
          >
            {errorAlert}
          </Alert>
        </Snackbar>
      </AcolitosContext.Provider>
    </div>
  );
};

const style = {
  modal: {
    // position: "absolute",
    top: "50%",
    left: "50%",
    // transform: "translate(-50%, -50%)",
    // width: "65%",
    bgcolor: "background.paper",
    // boxShadow: 24,
    p: 4,
    // borderRadius: 2,
  },
  modal_title: {
    textAlign: "center",
  },
};
